import classNames from 'classnames/bind';
import styles from './FaqSidebar.module.scss';
import { ChevronDown, ChevronUp, FormButton, FormInput, Heading } from '@/components';
import { FaqCategories } from '../FaqCategories/FaqCategories';
import { useState } from 'react';
import { useRouter } from 'next/compat/router';

let cx = classNames.bind(styles);

export function FaqSidebar({ mainCategories, basePath }) {
	const [search, setSearch] = useState('');
	const [isOpen, setIsOpen] = useState(false);
	const router = useRouter();

	function handleSubmit(e) {
		e.preventDefault();
		router.push(`${basePath}/search/${encodeURI(search)}`);
	}

	function handleOpen() {
		setIsOpen(!isOpen);
	}

	return (
		<div className={cx(['faq-sidebar', 'bg-neutral-lightest', isOpen && 'open'])}>
			<div className={cx(['accordion-header'])}>
				<button id="faq-accoridon-button" className={cx('accordion-button')} onClick={handleOpen} aria-controls='faq-accoridon-body' aria-expanded={isOpen ? true : false}>
					<Heading level="h2" className={cx(['sidebar-heading', 'is-style-heading-body'])}>
						Find your answer
					</Heading>
					<div className={cx('accordion-icon-container')}>{isOpen ? <ChevronUp className={cx('accordion-chevron')} /> : <ChevronDown className={cx('accordion-chevron')} />}</div>
				</button>
			</div>
			<div id="faq-accoridon-body" className={cx(['accordion-body'])} aria-labelledby='faq-accoridon-button' hidden={isOpen ? false : true}>
				<div>
					<Heading level="h3" className={cx(['search-heading', 'is-style-heading-eyebrow'])}>
						Search
					</Heading>
					<form className={cx(['search-from'])} onSubmit={(e) => handleSubmit(e)}>
						<FormInput label="Search FAQs" id="artlce-search" name="artlce-search" setValue={setSearch} value={search} className={cx(['search'])} pattern="^[a-zA-Z0-9 -]*$" minLength="3" required />
						<FormButton text="Search" className={cx(['search-btn'])} />
					</form>
					{mainCategories && <FaqCategories title="Browse By Topic" categories={mainCategories.categories} basePath={basePath} />}
				</div>
			</div>
		</div>
	);
}
